import { atom } from "recoil";

export const SelectedCampaignsAtom = atom<string[]>({
    key: "SelectedCampaignsAtom",
    default: [""],
});
